module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-BoldItalic-WebS.47c4dd18.eot";